import { createSlice } from "@reduxjs/toolkit";

const positionSlice = createSlice({
  name: "position",
  initialState: { value: {} },
  reducers: {
    positionDetails: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { positionDetails } = positionSlice.actions;
export default positionSlice.reducer;
